import TabelNpwp from "./TabelNpwp";

export default TabelNpwp;